export const QualificationCriteriaQueryKeys = {
  qcsAndPricing: (campaignId: string | undefined) => [
    "qcs-and-pricing",
    campaignId || "",
  ],
};
